import script from "./NologinTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./NologinTitle.vue?vue&type=script&setup=true&lang=ts"

import "./NologinTitle.vue?vue&type=style&index=0&id=6c388058&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c388058"]])

export default __exports__